import * as React from 'react';
import { TextField } from '@symphony-ui/uitoolkit-components';
import PopupButtons from './PopupButtons';
import Books from '../../../../../models/data/Books';
import Management from '../../../../../models/data/Management';
const BooksPopup = ({ data, hasOverride, save }) => {
    const [booksValue, setBooksValue] = React.useState(() => {
        const booksSize = data?.override?.management?.books?.size?.value ?? data?.data?.management?.books?.size?.value;
        return booksSize !== undefined ? (booksSize / 1000000).toString() : "";
    });
    const [combinedBooksValue, setCombinedBooksValue] = React.useState(() => {
        const combinedBooksSize = data?.override?.management?.combinedBooks?.size?.value ?? data?.data?.management?.combinedBooks?.size?.value;
        return combinedBooksSize !== undefined ? (combinedBooksSize / 1000000).toString() : "";
    });
    const inputRef = React.useRef(null);
    const onChangeBooks = React.useCallback((event) => {
        const { value } = event.target;
        if (value.match(/\d+/)) {
            setBooksValue(value);
        }
        else if (value === '') {
            setBooksValue("");
        }
        else {
            console.log("no match");
        }
    }, []);
    const onChangeCombinedBooks = React.useCallback((event) => {
        const { value } = event.target;
        if (value.match(/\d+/)) {
            setCombinedBooksValue(value);
        }
        else if (value === '') {
            setCombinedBooksValue("");
        }
        else {
            console.log("no match");
        }
    }, []);
    const management = React.useMemo(() => {
        const books = booksValue.match(/\d+/) ? new Books({ size: { value: Number.parseFloat(booksValue) * 1000000 } }) : undefined;
        const combinedBooks = combinedBooksValue.match(/\d+/) ? new Books({ size: { value: Number.parseFloat(combinedBooksValue) * 1000000 } }) : undefined;
        return new Management({ books, combinedBooks });
    }, [booksValue, combinedBooksValue]);
    React.useEffect(() => {
        const { current } = inputRef;
        if (current !== null) {
            current.focus();
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement(TextField, { label: "Books", onChange: onChangeBooks, ref: inputRef, value: booksValue }),
        React.createElement(TextField, { label: "Combined Books", onChange: onChangeCombinedBooks, value: combinedBooksValue }),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { isDisabled: false, value: management, hasOverride: hasOverride, save: save }))));
};
export default BooksPopup;
